/**
 * @deprecated This is a barely complete enum, and doesn't add value to the codebase.
 * Do not use.
 */
export enum HttpStatus {
  BAD_REQUEST = 400,
  CONFLICT = 409,
}
